import { z } from 'zod';
import { ValidationIssueSchema } from './product.js';

export const ValidationCodeSchema = z.enum([
  'CYCLE',
  'NO_NAME',
  'NO_UNIT',
  'NO_LINES',
  'NO_CODE',
  'CODE_INVALID',
  'CODE_TAKEN_LOCAL',
  'CODE_TAKEN_UNIT4',
  'CONFLICT',
  'CHILD_INVALID',
  'UNLINKED',
  'NOT_FOUND',
  'BLOCKED',
  'UNIT_MISMATCH',
  'QTY_INVALID',
  'PER_INVALID',
  'LOSS_INVALID',
  'DUPLICATE_COMPONENT',
  'UNIT4_ERROR',
  'TEXT_ARTICLE',
  'DN_MISMATCH',
  'DN_CHANGED',
  'DESCRIPTION_MISMATCH',
  'COST_PRICE_FROM_TEMPLATE',
]);
export type ValidationCode = z.infer<typeof ValidationCodeSchema>;

/**
 * Unit4-artikel 1 en 2 zijn tekstartikelen (zoeknaam TEKST): plaatshouder voor een regel die nog geen
 * echt artikelnummer heeft, bv. "niet eerder verkocht". Als component valideren ze nooit.
 */
export const UNIT4_TEXT_ARTICLE_CODES: readonly string[] = ['1', '2'];
export const isUnit4TextArticle = (code: string | null | undefined): boolean =>
  !!code && UNIT4_TEXT_ARTICLE_CODES.includes(code.trim());

export const ValidationResultSchema = z.object({
  ok: z.boolean(),
  productId: z.number().int(),
  issues: z.array(ValidationIssueSchema),
  errorCount: z.number().int(),
  warningCount: z.number().int(),
  /** post-order lijst van product-id's (kinderen eerst) */
  order: z.array(z.number().int()),
  validatedAt: z.string(),
});
export type ValidationResult = z.infer<typeof ValidationResultSchema>;
